import { store } from '@sonifi/wb-core/store/store';
import { initGuestRequestMenu } from '../Menu/services/grMenu.service';
import { redirect } from 'react-router';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';
import { getInicialNode } from '../Menu/services/helpers/grMenuHelper';
import { setNodePreviewSelected } from '../store/menu/guestRequestMenuSlice';

export async function loaderGrMenu({ params }) {
  const { groupId, platform, id } = params;

  const nodeId = await store.dispatch(
    initGuestRequestMenu({ groupId: parseInt(groupId), id, platform }),
  );

  if (nodeId) {
    return redirect(`${nodeId}`);
  }

  return {};
}

export async function loaderGrMenuId({ params }) {
  const { groupId, platform, id } = params;

  const {
    guestRequestMenu: { loadingMenu, nodePreviewSelected, serviceMenu },
  } = store.getState();

  if (loadingMenu !== LOADING_STATUS.success) {
    await store.dispatch(
      initGuestRequestMenu({ groupId: parseInt(groupId), id, platform }),
    );
  } else if (nodePreviewSelected?.id !== id) {
    const node = getInicialNode({ id, menu: serviceMenu.menu });
    store.dispatch(setNodePreviewSelected({ node }));
  }

  return {};
}
